// Telemetría LIGERA de reconexión BLE para el mensaje de soporte (printerSupportInfo).
//
// El comercio no ve ningún panel: cuando toca "Pedir ayuda", el mensaje de WhatsApp ya
// lleva el último resultado de reconexión (vía + estado + hace cuánto). Con eso soporte
// distingue en segundos las causas que en campo se confunden:
//   - getDevices ausente (flag de Chrome reseteado por un update) → silent nunca disponible.
//   - permiso revocado (datos del sitio borrados / Safety Check) → silent disponible pero falla.
//   - impresora apagada/lejos → prompt falla.
// Vive en memoria del módulo (se pierde al recargar, igual que el runtime BLE): refleja la
// SESIÓN actual, que es lo que soporte necesita diagnosticar.

export type ReconnectOutcome = {
  via: 'silent' | 'prompt';
  status: 'success' | 'failed' | 'cancelled';
  at: number; // epoch ms
};

let last: ReconnectOutcome | null = null;

export const recordReconnectOutcome = (outcome: ReconnectOutcome): void => {
  last = outcome;
};

export const lastReconnectOutcome = (): ReconnectOutcome | null => last;

// Solo para tests.
export const __resetReconnectTelemetryForTests = (): void => {
  last = null;
};
